import { createSignal, Match, Switch } from "solid-js";

import { Contacts } from "./Contacts";
import { Dates } from "./Dates";
import { Disks } from "./Disks";
import { Files } from "./Files";
import { Lyrics } from "./Lyrics";
import { Menu } from "./Menu";
import { Tracks } from "./Tracks";
import { Values } from "./Values";
import { Videos } from "./Videos";
import type { Page } from "../types";

export function App() {
    const [ page, setPage ] = createSignal<Page>("home");
    return <>
        <div>
            <Menu setPage={setPage} page={page()} />
        </div>
        <div>
            <Switch>
                <Match when={page() === "home"}>
                    <section id="admin-home">
                        <h2>Accueil</h2>
                        <div>
                            <h3>Page d'administration d'UTDO</h3>
                            <p>Attention à ne pas faire n'importe quoi, notamment sur les valeurs...</p>
                            <p>Il ne faut pas oublier que l'important, c'est les valeurs.</p>
                            <p>Pour ajouter un album, il faut suivre l'ordre du menu : d'abord on ajoute les paroles, puis on ajoute le disque et enfin on ajoute les pistes. Si une chanson n'a pas de paroles, il faut ignorer l'ajout de paroles, et choisir de n'ajouter aucune paroles lors de la création de la piste. Il est conseillé de créer le disque caché pendant la création des pistes et de le rendre visible une fois que ces dernières ont été ajoutées.</p>
                            <p>En cas de problème, n'hésitez pas à me contacter.</p>
                        </div>
                    </section>
                </Match>
                <Match when={page() === "contacts"}>
                    <Contacts/>
                </Match>
                <Match when={page() === "dates"}>
                    <Dates/>
                </Match>
                <Match when={page() === "disks"}>
                    <Disks/>
                </Match>
                <Match when={page() === "files"}>
                    <Files/>
                </Match>
                <Match when={page() === "lyrics"}>
                    <Lyrics/>
                </Match>
                <Match when={page() === "tracks"}>
                    <Tracks/>
                </Match>
                <Match when={page() === "values"}>
                    <Values/>
                </Match>
                <Match when={page() === "videos"}>
                    <Videos/>
                </Match>
            </Switch>
        </div>
    </>;
}